import Vue from 'vue'
import Router from 'vue-router'
import promise from 'es6-promise'

promise.polyfill();
Vue.use(Router);
const index = () => import('./pages/index');
const about = () => import('./pages/about');
const welfare = () => import('./pages/welfare');
const gift = () => import('./pages/gift');
export default new Router({
    mode: 'hash',
    scrollBehavior(to, from, savedPosition) {
        return {x: 0, y: 0}
    },
    routes: [
        {
            path: "/",
            name: "index",
            component: index
        },
        {
            path: "/about",
            name: "about",
            component: about
        },
        {
            path: "/welfare",
            name: "welfare",
            component: welfare
        },
        {
            path: "/gift",
            name: "gift",
            component: gift
        }
    ]
})